import {Swiper, Navigation, Pagination, Autoplay} from 'swiper';

export class ExpertShuffle {

    constructor() {

        if (document.getElementsByTagName('body')[0].classList.contains('neos-backend')) {
            return;
        }

        const container = document.querySelector('.expert-slider-items-container .swiper-wrapper');
        if (container && container.children.length) for (let i = container.children.length; i >= 0; i--) {
            container.appendChild(container.children[Math.random() * i | 0]);

        }

    }

}

//@todo refactor to a distinct place
export class SliderModule {
  constructor() {

  }

  init(){
    const swiperInstances: any = [];
    const sliders = document.querySelectorAll('.swiper-container:not(.swiper-custom-script)');
    Swiper.use([Navigation, Pagination, Autoplay]);
    if (!document.getElementsByTagName('body')[0].classList.contains('neos-backend'))
      sliders.forEach((elem: any, index) => {
        let config = JSON.parse(elem.getAttribute('data-swiper-config'));
        elem.classList.add(`instace-${index}`);
        if (elem.parentElement.querySelector('.swiper-pagination')) {
          elem.parentElement.querySelector('.swiper-pagination').classList.add(`pagination-${index}`);
        }
        if (elem.parentElement.querySelector('.swiper-button-prev')) {
          elem.parentElement.querySelector('.swiper-button-prev').classList.add(`prev-${index}`);
          elem.parentElement.querySelector('.swiper-button-next').classList.add(`next-${index}`);
        }

        swiperInstances[index] = new Swiper(elem, { //instance need to be unique (ex: some-slider)
          navigation: {
            prevEl: `.prev-${index}`,  //prev must be unique (ex: some-slider-prev)
            nextEl: `.next-${index}`, //next must be unique (ex: some-slider-next)
          },
          pagination: {
            el: '.pagination-' + index,
            type: 'bullets',
            clickable: true
          },
          calculateHeight: true,
          ...config
        });
      })
  }
}
